import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faCompass,
  faPlus,
  faBell,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/UseAuth';
import { useNotifications } from '../../hooks/useNotifications';
// --- INICIO DE LA MODIFICACIÓN 1: Importar LangLink ---
import { LangLink } from '../common/LangLink';
// --- FIN DE LA MODIFICACIÓN 1 ---

const MobileProfileSidebar = ({ onToggleQuickMenu }) => {
  const { t, i18n } = useTranslation(); // Se añade i18n
  const location = useLocation();
  const { user } = useAuth();
  const { unreadCount } = useNotifications();

  const isHidden =
    location.pathname.includes('/posts/') ||
    location.pathname.includes('/packs/') ||
    location.pathname.includes('/auth');

  if (isHidden) {
    return null;
  }

  if (!user) {
    return (
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 h-20 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-700 z-40"></nav>
    );
  }

  const isCreator = user.profileType === 'creator';

  const navItems = [
    { to: '/', icon: faHome, label: t('sidebar.home') },
    { to: '/explore', icon: faCompass, label: t('sidebar.explore') },
    {
      isAction: true,
      icon: faPlus,
      label: t('common.create'),
      show: isCreator,
    },
    {
      to: '/notifications',
      icon: faBell,
      label: t('sidebar.notifications'),
      badge: unreadCount > 0,
    },
    { to: '/my/profile', icon: faUser, label: t('sidebar.myProfile') },
  ];

  // --- INICIO DE LA MODIFICACIÓN 2: Lógica 'isActive' corregida para idiomas ---
  const currentPathWithoutLang = location.pathname.startsWith(
    `/${i18n.language}`
  )
    ? location.pathname.substring(i18n.language.length + 1)
    : location.pathname;

  const isActive = (to) => {
    if (to === '/') {
      return currentPathWithoutLang === '/' || currentPathWithoutLang === '';
    }
    return currentPathWithoutLang.startsWith(to);
  };

  const getNavLinkClass = (to) => {
    return `flex flex-col items-center justify-center gap-1 transition-colors w-full h-full ${
      isActive(to)
        ? 'text-primary'
        : 'text-neutral-500 dark:text-neutral-400 hover:text-primary'
    }`;
  };
  // --- FIN DE LA MODIFICACIÓN 2 ---

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 h-20 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-700 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-40 grid grid-cols-5 items-center">
      {navItems.map((item, index) => {
        if (item.isAction) {
          return item.show ? (
            <div
              key={index}
              className="relative flex justify-center items-center h-full"
            >
              <button
                onClick={onToggleQuickMenu}
                className="absolute -top-8 flex items-center justify-center w-16 h-16 bg-primary hover:bg-primary-dark text-white rounded-full shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-110"
                aria-label={item.label}
              >
                <FontAwesomeIcon icon={item.icon} size="2x" />
              </button>
            </div>
          ) : (
            <div key={index}></div>
          );
        }

        // --- INICIO DE LA MODIFICACIÓN 3: Usar LangLink en lugar de NavLink ---
        return (
          <LangLink
            to={item.to}
            key={item.to}
            className={getNavLinkClass(item.to)}
          >
            <div className="relative">
              <FontAwesomeIcon icon={item.icon} size="lg" />
              {item.badge && (
                <span className="absolute -top-1 -right-1 block h-2 w-2 rounded-full bg-primary ring-2 ring-white dark:ring-neutral-800"></span>
              )}
            </div>
            <span className="text-xs font-medium">{item.label}</span>
          </LangLink>
        );
        // --- FIN DE LA MODIFICACIÓN 3 ---
      })}
    </nav>
  );
};

export default MobileProfileSidebar;
